import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import Immutable from "immutable";
import momentTimeZone from "moment-timezone";
import { AddressInfo, MoveItemsInfo } from "../estimate_details/MoveDetails";
import { InvoiceList } from "../estimate_details/InvoiceList";
import { useHistory } from "react-router-dom";
export default function EstimateCompleted(props) {
  const { data,setListOfGoods } = props;
  const history = useHistory();
  //callback 0 or 1 check for move type.
  const inventoryData = Immutable.fromJS(data.items);
  const clientTz = momentTimeZone.tz.guess();

  const moveCompletedDate = momentTimeZone
    .utc(data.date_of_complete)
    .tz(clientTz);
  const JSX = (
    <div className="move-container">
      <AddressInfo
        movingFrom={data.moving_from}
        movingTo={data.moving_to}
        fromAddress={data.from_address}
        toAddress={data.to_address}
        estimateId={data.estimate_id}
        estimateDetails={data}
      />
      <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 dashboard-item-common-spacing">
          <MoveItemsInfo
            propertySize={data.property_size}
            callback={data.call_back}
            totalItems={data.total_items}
            items={data.items}
            serviceType={data.service_type}
            inventoryData={inventoryData}
            distance={data.distance}
          />
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 dashboard-item-common-spacing">
          <div className="completed-date-container">
            <div className="completed-label">Completed On</div>
            <div className="font-size-md">
              {`${moveCompletedDate.format(
                "MMM Do YYYY"
              )} at ${moveCompletedDate.format("h:mm a")}`}
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 move-action-list dashboard-item-common-spacing">
          <div className="d-flex flex-row mb-2">
            <InvoiceList
              balance={0}
              additionalAmount={0}
              estimateData={data}
              estimateStatus={6}
              setListOfGoods={setListOfGoods}
            />
            <button className="btn btn-primary btn-sm ml-2 w-100">
              {data.custom_status}
            </button>
          </div>
          <div className="d-flex my-1">
            {data.order_reviewed === "0" && (
              <button
                className="btn btn-sm btn-light w-100 light-btn border-0"
                onClick={() => {
                  history.push(
                    `/dashboard/packers-and-movers-vendor/write-review/${data.estimate_id}/${data["estimateAmount"]["vendor_id"]}`
                  );
                }}
              >
                <strong>
                  <FontAwesomeIcon icon={faStar} /> Rate Your Move{" "}
                </strong>
              </button>
            )}
          </div>
        </div>
      </div>

      <hr />
    </div>
  );
  return JSX;
}
